const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Vehicle registration document',
	'vehicleRegistrationDocument.description':
		'Upload clear photos of the requested sides of the vehicle registration document.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Front of the registration document',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Take a clear photo of the front of the registration document.',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'Front of the registration document',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Front of the registration document - example',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Front of the registration document',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Back of the registration document',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Take a clear photo of the back of the registration document.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Back of the registration document',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Back of the registration document - example',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Back of the registration document',
	'vehicleRegistrationDocument.validationHeadline': 'Missing photos',
	'vehicleRegistrationDocument.validationDescription': 'Please add the following photos:',
	'landing.stepDescription.vehicleRegistrationDocument':
		'Take photos of the vehicle registration document',
	'review.stepDescription.vehicleRegistrationDocument': 'Vehicle registration document',
	'onboardingStart.headline': 'Hello! Check your information so we can begin.',
	'onboardingStart.name': 'Name',
	'onboardingStart.plateNumber': 'Plate number:',
	'onboardingStart.year': 'Year',
	'onboardingStart.timeout': 'This link will be active until ',
	'onboardingStart.support': 'Need help? Call Solvd!',
	'onboarding.headline': 'Ready to start your digital inspection?',
	'onboarding.paragraph': 'Before starting the process, please consider the following:',
	'onboarding.documents':
		"Have the <b>keys</b> and the <b>vehicle's registration card</b> available.",
	'onboarding.camera': 'Photos can only be taken using your <b>smartphone camera</b>.',
	'onboarding.internet':
		'Be in a place with <b>good lighting</b> and a <b>strong internet connection</b>.',
	'onboarding.vehicle':
		'Ensure the vehicle is <b>clean</b>, <b>accessible from all angles</b>, and that all <b>windows are closed</b>.',
	poweredBy: 'Powered by <ce>ControlExpert</ce> a <solvd>Solvd</solvd> group company',
	'onboarding.terms.before': 'Before beginning, please confirm the following:',
	'onboarding.terms.url': 'I agree with <tclink>Terms and conditions</tclink>.',
	'button.anotherImage': 'Take another photo',
	'button.acceptImage': 'Accept the photo',
	'button.acceptMileage': 'Correct',
	'validationContainer.correct': 'Correct',
	'damageImages.title': 'Damage Photos',
	'damageImages.booleanRadioGroupLabel': 'Does your vehicle have any damage?',
	'damageImages.booleanRadioGroupLabelLeft': 'No',
	'damageImages.booleanRadioGroupLabelRight': 'Yes',
	'vehicleFrontLeftPerspectiveImage.title': 'Photo of the vehicle front left',
	'vehicleFrontLeftPerspectiveImage.description':
		'Take photo of the front left diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'vehicleFrontRightPerspectiveImage.title': 'Photo of the vehicle front right',
	'vehicleFrontRightPerspectiveImage.description':
		'Take photo of the front right diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'vehicleRearLeftPerspectiveImage.title': 'Photo of the vehicle rear left',
	'vehicleRearLeftPerspectiveImage.description':
		'Take photo of the rear left diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'vehicleRearRightPerspectiveImage.title': 'Photo of the vehicle rear right',
	'vehicleRearRightPerspectiveImage.description':
		'Take photo of the rear right diagonal, ensuring the entire car is in the frame and the license plate is visible.',
	'dashboardMileage.title': 'Photo of the odometer',
	'vehicleMileage.description':
		'Capture a photo of the odometer, ensuring that the digital reading is in sharp focus and completely legible.',
	'review.title': 'Summary of your digital inspection',
	'timeout.paragraph.first': 'Your case has expired or the link you accessed is incorrect.',
	'review.stepDescription.group.perspectiveImages': 'Vehicle overview photos',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Photo of the vehicle front left',
	'review.stepDescription.vehicleFrontRightPerspective': 'Photo of the vehicle front right',
	'review.stepDescription.vehicleRearLeftPerspective': 'Photo of the vehicle rear left',
	'review.stepDescription.vehicleRearRightPerspective': 'Photo of the vehicle rear right',
	'review.stepDescription.group.additionalImages': 'Additional pictures',
	'review.stepDescription.questions': 'Vehicle information',
	'review.stepDescription.fourAdditionalDocuments': 'Vehicle details',
	'blockedByDevice.paragraph.first':
		'This link can only be used on smartphones. Scan the following QR code with your smartphone to begin the process.',
	'blockedByDevice.paragraph.second':
		'A quick tip: when opening the link, you should be near the vehicle and have your documents ready.',
	'landscapeModeDetected.title': 'Auto-rotate enabled',
	'landscapeModeDetected.text':
		'Please disable auto-rotate on your device for a better camera experience.',
	'button.hint': "Where's my VIN number located?",
	'hint.vin': 'XXXXXXXXXXXXXXXXX',
	'hint.vin.title': 'Possible VIN locations',
	'hint.vin.description': 'It can typically be found in those 4 locations:',
	'hint.vin.location1': "On the dashboard, visible through the windshield on the driver's side.",
	'hint.vin.location2': "On the driver's side door frame, near the latch.",
	'hint.vin.location3': 'In the engine bay, often on a metal plate.',
	'hint.vin.location4': 'Front end of frame (older vehicles).',
	'thankYou.message': 'Your request is being reviewed by our technical team.',
	'feedback.title': 'We would appreciate your feedback.',
	'feedback.message':
		'On a scale of 0 to 5, how would you rate your experience having your digital inspection done with us?',
	'feedback.helpImprove': 'Help us improve (optional):',
	'feedback.error.maxLength': 'Feedback cannot exceed more than {maxLength} characters.',
	'dashboardMileage.placeholder.updated': 'insert mileage (km)',
	'questions.DoesTheVehicleHaveCNG': 'Doses the vehicle have CNG?',
	'questions.ArmoredVehicle': 'Armored vehicle?',
	'questions.DoesTheVehicleHaveModifiedSuspension': 'Does the vehicle have modified suspension?',
	'questions.WasTheChassisNumberRemarked': 'Was the chassis number remarked?',
	'questions.yes': 'Yes',
	'questions.no': 'No',
	'questions.paragraph':
		'If the vehicle has any modifications that you wish to document, please answer the following questions:',
	'questions.title': 'Vehicle information',
	'fullscreen.prompt': 'Fullscreen mode is available for a better experience',
	'fullscreen.prompt.accept': 'Open in fullscreen',
	'fullscreen.prompt.dismiss': 'Continue',

	'additionalDocuments.additionalDocumentImages': 'Photos of additional documents',
	'additionalDocuments.headline.first': 'Additional documents',
	'additionalDocuments.headline.second':
		'Add photos of additional documents (e.g. statements of the perpetrator of a collision, notes from the police, vehicle purchase agreement and other property documents) - if they have not been taken, press the skip button.',
	'additionalDocuments.optionalDocumentImages':
		'Optionally add more photos of additional documents.',
	'approval.additionalCosts': 'Additional costs',
	'approval.button.approve': 'I accept the offer',
	'approval.button.disapprove': 'I do not accept the offer',
	'approval.calculationPDF': 'Calculation overview PDF',
	'approval.description':
		'Please check that the bank account number provided below is correct. If so, approve the cost estimate and the above amount will be transferred to your account.',
	'approval.discount': 'Discount',
	'approval.headline': 'Repair amount',
	'approval.labourCosts': 'Labour costs',
	'approval.lacquerCosts': 'Lacquer work',
	'approval.lacquerMatCosts': 'Paint materials',
	'approval.payoutAmount': 'Payout amount',
	'approval.repairAmount': 'Repair amount',
	'approval.repairAmountGross': 'An amount of the damage',
	'approval.retention': 'Retention',
	'approval.smallCosts': 'Small Additional costs',
	'approval.sparePartCosts': 'Spare parts',
	'approval.tax': 'VAT',
	'blockedByDevice.headline': 'PolicyCheck does not support desktop browsers',
	'blockedByDevice.description':
		'PolicyCheck is using a desktop browser.\r\nThe PolicyCheck platform performs documenting cases using mobile devices.\r\nTo continue, please run the PolicyCheck link on a mobile device.',
	'bodyshop.headline': 'Workshops in your area',
	'bodyshop.mainError': 'Workshops in your area could not be loaded ...',
	'bodyshop.mainLoader.loadingLocation': 'Determining your location ...',
	'bodyshop.mainLoader.loadingWorkshop': 'Loading workshops in your area ...',
	'button.accept': 'Accept',
	'button.addLater': 'Add later',
	'button.backchangeImage': 'Back & change image',
	'button.call': 'Call',
	'button.changeImage': 'Change photo',
	'button.close': 'Close',
	'button.contact': 'Contact',
	'button.continue': 'Continue',
	'button.dataProtection': 'Data protection',
	'button.deleteImage': 'Delete photo',
	'photo.deleteConfirmation.title': 'Are you sure you want to delete the photo?',
	'photo.deleteConfirmation.description':
		'If you delete the photo, you will be asked to take a new one.',
	'photo.deleteConfirmation.cancel': 'Cancel',
	'photo.deleteConfirmation.confirm': 'Delete photo',
	'button.help': 'Help',
	'button.imprint': 'Imprint',
	'button.liveChat': 'Live-Chat',
	'button.next': 'Next',
	'button.ok': 'Ok',
	'button.onApproval': 'Get calculation',
	'button.onCallback': 'Callback Note received',
	'button.onExpertRequest': 'Expert request',
	'button.onInsuranceExpert': 'Steering out to insurance expert',
	'button.onLanding': 'Without onboarding',
	'button.onOnboarding': 'Onboarding',
	'button.onVideocall': 'Video review',
	'button.payout': 'Yes, please pay',
	'button.prev': 'Back',
	'button.repair': 'Arrange for repair',
	'button.select': 'Select',
	'button.selectPhoto': 'Select a photo',
	'button.showTutorial': 'Watch tutorial',
	'button.showWhatsApp': 'WhatsApp-Message',
	'button.skip': 'Skip',
	'button.start': 'Start',
	'calculationDetailsModal.additionalCosts': 'Additional costs',
	'calculationDetailsModal.labourCosts': 'Labour costs',
	'calculationDetailsModal.lacquerCosts': 'Lacquer costs',
	'calculationDetailsModal.spareParts': 'Spare parts',
	'calculationDetailsModal.total': 'Total',
	'callback.description':
		'Unfortunately no calculation was possible in your case. We will call you within 24 hours on weekdays to discuss further action with you.',
	'callback.headline': 'Your damage has been assessed.',
	'completeDamageDescriptionModal.description': 'Please describe briefly how the damage occurred.',
	'completeDamageDescriptionModal.headline': 'Hint',
	'completeDamageImages.description': 'Add at least 2 damage photos from different distances.',
	'completeDamageImages.headline': 'Hint',
	'completeDashboardMileageModal.dashboardImage': 'Photo of the mileage',
	'completeDashboardMileageModal.description': 'Please provide the information below:',
	'completeDashboardMileageModal.hasValidMileage': 'The vehicle mileage',
	'completeDashboardMileageModal.headline': 'Hint',
	'completeFourAdditionalPicturesModal.description': 'Please add the following information:',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Photo of the mileage',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage':
		"Photo of the vehicle's dashboard",
	'completeFourAdditionalPicturesModal.hasVINImage': "Photo of the vehicle's VIN number",
	'completeFourAdditionalPicturesModal.hasWindshieldImage':
		"Photo of the vehicle's front windshield",
	'completeFourAdditionalPicturesModal.headline': 'Hint',
	'completeOverallDashboardImageModal.description': 'Please add the following information:',
	'completeOverallDashboardImageModal.hasOverallDashboardImage': 'Photo of the dashboard',
	'completeOverallDashboardImageModal.headline': 'Hint',
	'completePayoutInformationModal.accountHolder': 'Account holder',
	'completePayoutInformationModal.accountHolderIBAN': 'IBAN of the account holder',
	'completePayoutInformationModal.accountHolderIBANInvalid': 'Invalid IBAN',
	'completePayoutInformationModal.description': 'Please add the following information:',
	'completePayoutInformationModal.headline': 'Hint',
	'completePoliceReportModal.description': 'Please add the following information:',
	'completePoliceReportModal.hasAccidentOnAlcoholOrDrugs':
		'Were you under the influence of alcohol or drugs?',
	'completePoliceReportModal.hasAccidentOwnFault': 'Did you cause the accident?',
	'completePoliceReportModal.hasDamageDescription': 'Damage description',
	'completePoliceReportModal.hasPoliceInformed': 'Was the accident recorded by police?',
	'completePoliceReportModal.hasPoliceReportExists': 'Is there a police report?',
	'completePoliceReportModal.headline': 'Hint',
	'completeVehicleImagesModal.description': 'Please add the following information:',
	'completeVehicleImagesModal.hasVehicleImageFront': 'Photo of the vehicle front',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Photo of the vehicle front left',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Photo of the vehicle front right',
	'completeVehicleImagesModal.hasVehicleImageLeft': 'Photo of the vehicle left',
	'completeVehicleImagesModal.hasVehicleImageRear': 'Photo of the vehicle back',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Photo of the vehicle rear left',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Photo of the vehicle rear right',
	'completeVehicleImagesModal.hasVehicleImageRight': 'Photo of the vehicle right',
	'completeVehicleImagesModal.headline': 'Hint',
	'completeVehicleInformationModal.dashboardImage': 'Photo of the mileage',
	'completeVehicleInformationModal.description': 'Please add the following information:',
	'completeVehicleInformationModal.hasValidMileage': 'Mileage of the vehicle',
	'completeVehicleInformationModal.headline': 'Hint',
	'completeVehicleInformationModal.isRegistrationDocument2Uploaded':
		'Photo of the vehicle registration certificate (reverse)',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Photo of the vehicle registration',
	'completeVinModal.description': 'Please provide the information below:',
	'completeVinModal.hasVin': 'Photo of the VIN number',
	'completeVinModal.headline': 'Hint',
	'completeWindshieldImageModal.description': 'Please add the following information:',
	'completeWindshieldImageModal.hasWindshieldImage': 'Photo of the windshield',
	'completeWindshieldImageModal.headline': 'Hint',
	'connectionError.description': 'Connection error. Please upload picture again.',
	'connectionError.title': 'Connection error',
	'damageDescription.button.back': '« Back',
	'damageDescription.button.help': 'Help',
	'damageDescription.button.next': 'Next »',
	'damageDescription.headline.first': 'Damage Description',
	'damageDescription.paragraph.first':
		'Please briefly describe how the damage has occurred. You can also use the dictation feature of your mobile phone. Click to the text field and hold the microphone icon.',
	'damageDescription.placeholder':
		'For example: At an intersection another car hit me from the side. My front left fender was pushed in.',
	'damageImages.additionalImages': 'Additional damage images',
	'damageImages.description':
		'Add at least {imageCount, number} damage {imageCount, plural, one {photo} other {photos from different distances (close-up / entire component)}}. Important: The damage must be visible. Based on the {imageCount, plural, one {picture} other {pictures}}, we create the calculation.',
	'damageImages.headline': 'Damage Images',
	'damageImages.optionalDamageImages':
		'Optionally add further damage pictures, which additionally document the damage.',
	'damageImages.photo': 'photo of the damage',
	'damageImagesExampleModal.headline': 'Damage pictures - example',

	'additionalDamagePictures.title': 'Damage Photos',
	'damagedImages.description': 'You can add up to {imageCount, number} photos',
	'damagedImages.booleanRadioGroupLabel': 'Does your vehicle have any damage?',
	'damagedImages.booleanRadioGroupLabelLeft': 'No',
	'damagedImages.booleanRadioGroupLabelRight': 'Yes',
	'button.photo.take': 'Take photo',

	'photoUploading.title': 'Uploading',
	'photoAnalyzing.title': 'Analyzing',
	'photoLoading.title': 'Loading',

	'dashboardImageExampleModal.headline': 'Dashboard photo - example',
	'dashboardMileage.dashboard.paragraph':
		'Take a photo of the vehicle dashboard with fully visible mileage. If your vehicle has electronic displays, please turn them on.',
	'dashboardMileage.dashboard.title': 'Photo of the mileage',
	'dashboardMileage.headline.first': 'Mileage',
	'dashboardMileage.paragraph.first': 'Enter the vehicle mileage.',
	'dashboardMileage.input.error': 'Please enter the current mileage of the vehicle',
	'dashboardMileage.paragraph.mileageAutoFilled':
		'Mileage was automatically filled based on uploaded photo. Please check if value is proper',
	'dashboardMileage.placeholder': 'for example 150000 km',
	'dataPrivacyModal.headline': 'The terms and conditions',
	'editPhoto.edit': 'Change',
	enumeration: '{position, select, first {} last { and } other {, }}{enumeration}',
	'feedback.button.send': 'Send feedback',
	'feedback.description':
		'We hope that you were satisfied with our service and look forward to your feedback.',
	'feedback.headline': 'Thank you for using application!',
	'feedback.headline.policyCheck': 'Thank you for using PolicyCheck!',
	'feedback.rating': 'How do you rate claims processing with EasyClaim?',
	'feedback.rating.policyCheck': 'How do you rate the car inspection with PolicyCheck?',
	'feedback.yourOpinion': 'Your opinion',
	'feedback.comment.placeholder': 'Add your comment',
	'fourAdditionalPictures.mileage.description':
		'Please take a photo of your mileage. If your vehicle has a digital display, please switch it on.',
	'fourAdditionalPictures.mileage.enter': "Enter the vehicle's mileage",
	'fourAdditionalPictures.mileage.title': 'Mileage',
	'fourAdditionalPictures.overallDashboard.description':
		"Photograph your vehicle's dashboard completely.",
	'fourAdditionalPictures.overallDashboard.title': "Vehicle's dashboard",
	'fourAdditionalPictures.title': 'Additional pictures',
	'fourAdditionalPictures.vin.description':
		"Please take a photo of your vehicle's VIN number. You could find this on the driver's door seal or the bottom left corner of the windshield.",
	'fourAdditionalPictures.vin.title': "Vehicle's VIN number",
	'fourAdditionalPictures.windshield.description':
		"Please take a detailed photo of your vehicle's front windshield.",
	'fourAdditionalPictures.windshield.title': "Vehicle's front windshield",
	'fourAdditionalPicturesExampleModal.button.close': 'Close',
	'fourAdditionalPicturesExampleModal.headline.first': 'Additional pictures',

	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Exemplary photo',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Exemplary photo',

	'fourAdditionalPictures.windshield.exampleModalTitle': 'Exemplary photo',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Exemplary photo',

	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Photo of the front left diagonal',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Photo of the rear left diagonal',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Photo of the rear right diagonal',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Photo of the front right diagonal',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Exemplary photo',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Exemplary photo',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Exemplary photo',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Exemplary photo',

	'fourPerspectivesExampleModal.button.close': 'Close',
	'fourPerspectivesExampleModal.headline.first': 'Vehicle overview photos – an example',
	'helpModal.description':
		"You can't get any further with one step or have questions about the application? Please contact us! We will be glad to help you:",
	'helpModal.headline': 'Help',
	'imageRecognitionFeedback.isDamageVisible.infoText':
		'Make sure the attached photo shows the <b> damage </b> and continue.',
	'imageRecognitionFeedback.isDamageVisible.title': 'Damage',
	'imageRecognitionFeedback.isDamageVisible.titleWarning': 'Damage',
	'imageRecognitionFeedback.isFrontLeftPerspectiveVisible.infoText':
		'Make sure the <b> Skew - Left Front </b> perspective of the vehicle is fully visible and continue.',
	'imageRecognitionFeedback.isFrontLeftPerspectiveVisible.title': 'Diagonal at the front',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.infoText':
		'Make sure the <b> slanted front </b> perspective of the vehicle is fully visible and continue.',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.title': 'Diagonal at the front',
	'imageRecognitionFeedback.isRearPerspectiveVisible.infoText':
		'Make sure the <b> slanted rear </b> perspective of the vehicle is fully visible and continue.',
	'imageRecognitionFeedback.isRearPerspectiveVisible.title': 'Diagonal at the back',
	'imageRecognitionFeedback.isRearPerspectiveVisible.titleWarning': 'Diagonal at the back',
	'imageRecognitionFeedback.isRearRightPerspectiveVisible.infoText':
		'Make sure the <b> diagonal - right rear </b> perspective of the vehicle is fully visible and continue.',
	'imageRecognitionFeedback.isRearRightPerspectiveVisible.title': 'Diagonal at the back',
	'imageRecognitionFeedback.isRearRightPerspectiveVisible.titleWarning': 'Diagonal at the back',
	'imageRecognitionFeedback.isVinVisible.infoText':
		'Make sure the attached photo shows the <b> VIN </b> number and continue.',
	'imageRecognitionFeedback.isVinVisible.title': 'A photo with a visible VIN number',
	'imageRecognitionFeedback.isVinVisible.titleWarning': 'A photo with a visible VIN number',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Exemplary photo',
	'imageRecognitionMismatchModal.headline': 'Are you sure you added the right photo?',
	'impactDirections.description': 'Impact Directions Description',
	'impactDirections.title': 'Impact Directions Title',
	'impactDirections.button.next': 'Check Offer',
	'insuranceExpert.description':
		'Thank you very much. Your damage has been assessed. We will get in touch with you shortly to discuss the next steps with you.',
	'insuranceExpert.headline': 'We will contact you shortly.',
	'label.details': 'Details',
	'landing.aboutEasyclaim': 'What the EasyClaim is?',
	'landing.aboutPolicyCheck': 'What the PolicyCheck is?',
	'landing.changeLang': 'To change language, click here.',
	'chooseLang.headline': 'Choose your preferred language',
	'landing.dataPrivacyLink': 'Processing and protection of personal data',
	'landing.headline': 'Repair estimate in just a few steps:',
	'landing.headline.policyCheck': 'Car inspection on just few steps:',
	'landing.paragraph':
		'Please take 6 photos of the vehicle and a photo of the registration certificate. <br> Remember that the photos are sharp and taken in daylight.',

	'landing.additional-informations-section.title':
		'Before starting the inspection of your vehicle, check that:',
	'landing.additional-informations-section.text':
		'<ul>' +
		'<li>you have the keys and the registration certificate at hand</li>' +
		'<li>you are in a place with good light and mobile network</li>' +
		'<li>the vehicle is accessible from all angles and all side windows are closed</li>' +
		'</ul>',
	'landing.stepDescription.additionalDocuments': 'Take photos of perpetrators statement',
	'landing.stepDescription.damageDescription': 'Describe the damage',
	'landing.stepDescription.damageImages': 'Take photos of the damage',
	'landing.stepDescription.feedback': 'Give us your feedback',
	'landing.stepDescription.fourAdditionalPictures': 'Upload pictures',
	'landing.stepDescription.fourDiagonalPerspectives': 'Take the required pictures',
	'landing.stepDescription.vehicleImages': 'Take photos of the vehicle',
	'landing.stepDescription.vehicleInformation': 'Vehicle details',
	'landing.stepDescription.vinPicture': 'Add a photo of the VIN on the vehicle',
	'landing.stepDescription.fourAdditionalDocuments': 'Take photos of documents',
	'landing.termsAndConditionsLink': 'Accept the terms and conditions',
	'landing.termsAndConditionsLinkDescription':
		'To start, please accept the terms and conditions and click next.',
	'loader.error': 'Your process could not be loaded. Please try again later...',
	'loader.loading': 'Loading data ...',
	'mainError.tryAgain': 'Try again',
	'mainMenu.contact': 'Contact us',
	'mainMenu.contact.officeHours': 'Our service times: Monday - Friday 8:00 - 20:00',
	'mainMenu.contactDescription':
		'Do you have any questions? give us a call using this phone number: {hotlineNumber}',
	'mainMenu.dataPrivacy': 'Data protection',
	'mainMenu.description': 'Click on the button to view the privacy policy.',
	'mainMenu.headline': 'Data protection',
	'mainMenu.imprintDescription': 'Click on the button to open the imprint.',
	'mainMenu.imprintLink': 'Imprint',
	'necessaryDocuments.bankAccountExample.description':
		'For example:82 1020 0000 0000 0000 0000 0001',
	'necessaryDocuments.bankAccountExample.headline': 'Bank account number',
	'necessaryDocuments.damageImages.description': 'Damage photos - an example',
	'necessaryDocuments.damageImages.headline': 'Damage photos',
	'necessaryDocuments.dashboardImage.description': 'Photo of the mileage - an example',
	'necessaryDocuments.dashboardImage.headline': 'Photo of the mileage',
	'necessaryDocuments.headline.first': 'Necessary documents',
	'necessaryDocuments.paragraph.first':
		'To use the EasyClaim application you will need to prepare the following photos: ',
	'necessaryDocuments.registrationDocument.description':
		'Photo of the registration certificate (the front)',
	'necessaryDocuments.registrationDocument.description_inner':
		'Photo of the registration certificate (the reverse)',
	'necessaryDocuments.registrationDocument.headline': 'Photos of the registration certificate',
	'necessaryDocuments.statementImageExample.description':
		'for example, in the event of a collision, a declaration of the perpetrator of the collision',
	'necessaryDocuments.statementImageExample.headline': 'Photos of additional documents',
	'necessaryDocuments.vehicleImages.description': 'Vehicle overview photos – an example',
	'necessaryDocuments.vehicleImages.headline': 'Vehicle overview photos',
	'necessaryDocuments.vinImage.description': 'Photo of the VIN number - an example',
	'necessaryDocuments.vinImage.headline': 'Photo of the VIN number',
	'onboarding.button.finish': "Let's go »",
	'onboarding.button.next': 'Next »',
	'onboarding.headline.first': 'Take damage pictures',
	'onboarding.headline.second': 'Let calculate',
	'onboarding.headline.third': 'Get calculation',
	'onboarding.link.dataPrivacy': 'Accept data protection',
	'onboarding.link.skip': 'Skip',
	'onboarding.paragraph.first':
		'A car expert uses the pictures to calculate the amount of damage to the vehicle.',
	'onboarding.paragraph.second':
		'Simply upload a photo from the vehicle registration and the damage of the car.',
	'onboarding.paragraph.third':
		'Within a few hours you will receive the calculation. You can now decide to pay out the repair amount or to have the vehicle repaired at the bodyshop ',
	'overallDashboardImage.description': 'Please take a photo of the dashboard',
	'overallDashboardImage.headline': 'Overall dashboard image',
	'overallDashboardImage.title': 'Overall dashboard image',
	'overallDashboardImageExampleModal.button.close': 'Close',
	'overallDashboardImageExampleModal.headline.first': 'Photo of the dashboard - an example',
	'payout.button.back': '« Back',
	'payout.button.help': 'Help',
	'payout.button.payoutConfirm': 'Confirm payout »',
	'payout.headline.first': 'Bank account',
	'payout.headline.second': 'Bank account owner',
	'payout.headline.third': 'IBAN',
	'payout.paragraph': 'Please provide the bank account number for the compensation payment.',
	'perspective.front.left': 'front left',
	'perspective.front.right': 'front right',
	'perspective.rear.left': 'rear left',
	'perspective.rear.right': 'rear right',
	'registrationDocumentExampleModal.headline': 'Photo of the registration certificate - example',
	'resolverequest.button.continue': 'Submit answer',
	'resolverequest.headline': 'Additional Information required',
	'resolverequest.onload': 'Loading request...',
	'resolverequest.onload.error':
		'An error occurred while loading the request. Please try again later.',
	'resolverequest.perspective.paragraph':
		'Fotografieren Sie Ihr Fahrzeug schräg von vorne links und von hinten rechts. Das Kfz-Kennzeichen muss lesbar sein. Die Bilder werden benötigt, um einen Gesamteindruck des Fahrzeugs zu erhalten und das Kfz-Kennzeichen mit dem Fahrzeugschein abzugleichen.',
	'resolverequest.question.headline': 'We have a question',
	'review.button.back': '« Back',
	'review.button.close': 'Finish »',
	'review.button.help': 'Help',
	'review.button.next': 'Next',
	'review.editViewButton': 'View / Edit',
	'review.headline.first': 'Check',
	'review.paragraph.first':
		'Please check your data before clicking "Finish". You will receive a summary of the entered data..',
	'review.stepDescription.damageImages': 'Damage Images',
	'review.stepDescription.fourDiagonalPerspectives': 'Pictures of the perspectives',
	'review.stepDescription.mileage': 'Mileage',
	'review.stepDescription.overallDashboard': 'Picture of the dashboard',
	'review.stepDescription.vehicleFrontPerspectiveImage': 'Pictures of the front of the vehicle',
	'review.stepDescription.vehicleImages': 'Vehicle overview photos',
	'review.stepDescription.vehicleInformation': 'Vehicle details',
	'review.stepDescription.vehicleLeftPerspectiveImage': 'Pictures of the left of the vehicle',
	'review.stepDescription.vehicleRearPerspectiveImage': 'Pictures of the back of the vehicle',
	'review.stepDescription.vehicleRightPerspectiveImage': 'Pictures of the right of the vehicle',
	'review.stepDescription.vinPicture': 'Photo of the VIN number',
	'review.stepDescription.windshield': 'Picture of the windshield',
	'review.stepDescription.additionalDocuments': 'Additional documents',
	'review.stepDescription.fourAdditionalPictures': 'Additional pictures',
	'thanks.calculationPDF': 'PDF calculation preview',
	'thanks.headline.first': 'Thank you!',
	'thanks.paragraph.first': 'Thank you for using application!',
	'thanksForFeedback.headline.first': 'Thank you for your Feedback!',
	'thanksForFeedback.paragraph.first':
		"Your opinion about our service is very important to us. We're constantly working to improve EasyClaim and your feedback is an important key to our success.",
	'timeout.bottom': ' ',
	'timeout.headline.first': 'The link to the application is no longer active!',
	'tooManyAttempts.description':
		'Unfortunately, you reached the limit of maximum open sessions. Our consultants will contact you later.',
	'tooManyAttempts.title': 'Too many sessions',
	'tutorialModal.headline.first': 'What is behind EasyClaim?',
	'tutorialModal.headline.first.policyCheck': 'What is behind PolicyCheck?',
	'tutorialModal.paragraph.first':
		'EasyClaim is suitable for almost all body damage to a car. Your damage pictures and the accident description will be forwarded directly to one of our 350 car experts where the pictures are analyzed and claimed. Our expert teams have all worked practically for years in the workshop themselves and understand their craft very well. In addition, for more than 16 years, we have been examining claims and maintenance receipts from almost all major insurance companies and vehicle manufacturers. Your data will be compared with over 50 million verified transactions from the past and supplemented by the practical know-how of our car experts. In addition, we have built up a very extensive database over the years. We know what each screw at every manufacturer for each model costs, and what steps are needed to replace or repair a car part.',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck is a quick vehicle inspection. The inspection process consists of 8 simple steps.',
	'tutorialModal.paragraph.second':
		'All these circumstances allow us to provide you with a realistic cost estimate in such a short time.',
	'upload.message':
		'Your data will be uploaded. Depending on your internet connection, this process can take several minutes.',
	'vehicleImages.backOverview': 'Back photo of the vehicle',
	'vehicleImages.description': 'Please take photos as instructed.',
	'vehicleImages.details.first':
		'Add a photo of the car that shows the entire front and left side of the vehicle, including the front number plate.',
	'vehicleImages.details.fourth': 'The left of the vehicle',
	'vehicleImages.details.frontleft':
		'Take a photo of the vehicle with the whole front and left side. The license plate should be readable.',
	'vehicleImages.details.rearright':
		'Add a photo of the car that shows the entire rear and right side of the vehicle, including the rear number plate.',
	'vehicleImages.details.second': 'The right of the vehicle',
	'vehicleImages.details.third': 'The back of the vehicle',
	'vehicleImages.frontOverview': 'Front photo of the vehicle',
	'vehicleImages.leftFrontOverview': 'Diagonal photo of the front',
	'vehicleImages.leftOverview': 'Left photo of the vehicle',
	'vehicleImages.leftRearOverview': 'Diagonal photo of the back - left side',
	'vehicleImages.overviewPhotos': 'Overview photos of the car',
	'vehicleImages.overviewPhotos.subtitle': 'Photograph vehicle',
	'vehicleImages.rightFrontOverview': 'Diagonal photo of the front - right side',
	'vehicleImages.rightOverview': 'Right photo of the vehicle',
	'vehicleImages.rightRearOverview': 'Diagonal photo of the back',
	'vehicleImagesExampleModal.button.close': 'Close',
	'vehicleImagesExampleModal.headline.first': 'Overview Car – Example',
	'vehicleInformation.button.back': '« Back',
	'vehicleInformation.button.help': 'Help',
	'vehicleInformation.button.next': 'Next »',
	'vehicleInformation.headline.first': 'Vehicle details',
	'vehicleInformation.headline.fourth': 'Photo of the registration certificate (the reverse)',
	'vehicleInformation.headline.second': 'Photo of the registration certificate (the front)',
	'vehicleInformation.paragraph.first':
		'Take a photo of the vehicle registration certificate (the front)',
	'vehicleInformation.paragraph.fourth':
		'Take a photo of the vehicle registration certificate (the reverse)',
	'vinImagesExampleModal.button.close': 'Close',
	'vinImagesExampleModal.headline.first': 'Photo of the VIN number – an example',
	'vinPicture.description': 'Take a photo of the VIN number',
	'vinPicture.headline': 'Photo of the VIN number',
	'vinPicture.title': 'Photo of the VIN number',
	'waitForAudit.callBack': 'For further questions, we are happy to help you:',
	'waitForAudit.description':
		'The data is submitted successfully. Our experts will now check the damage based on your data and generate a cost calculation within 2 hours (Mon-Fri 8 am-8 pm, Sat 8 am-12 pm, excluding public holidays). You will be notified by e-mail or SMS as soon as the calculation is completed.',
	'waitForAudit.description.damageFound':
		'Our expert will check the damage and calculate the payment amount within 2 hours (on working days).We will notify you as soon as the calculation of the damage is completed.',
	'waitForAudit.description.damageNotFound':
		'Our expert will check the damage and calculate the payment amount within 2 hours (on working days).We will notify you as soon as the calculation of the damage is completed.',
	'waitForAudit.thankYou': 'Thank you!',
	'waitforAudit.finish': 'Finish',
	'windshieldExampleModal.button.close': 'Close',
	'windshieldExampleModal.headline.first': 'Photo of the windshield - an example',
	'windshieldImage.description': 'Please take a photo of the windshield',
	'windshieldImage.headline': 'Windshield image',
	'windshieldImage.title': 'Windshield image',
	'withoutPayout.description':
		'Do you wish a repair? We would be happy to assist you in selecting a qualified workshop in your area.',
	'withoutPayout.footer':
		'We will contact you as soon as possible to discuss the further procedure.',
	'withoutPayout.headline': 'We will gladly support you!',
	'testcasemodal.headline': 'Test case warning!',
	'testcasemodal.accept': 'Accept',
	'testcasemodal.paragraph': 'Be aware it is a test case!',
	'testcasewarningalert.paragraph': 'This is test case!',
	'additionaldamagewarningalert.paragraph':
		'Our Artificial Intelligence has detected possible damages in the pictures, please be aware that these pictures will be reviewed by one of our experts.',

	'button.reverse': 'Keep Photo Milege',
	'button.confirm': 'Confirm My Mileage',
	'mileageModal.headline': "Let's check if the mileage value you added is correct",
	'mileageModal.paragraph':
		'The photo mileage value differs from that entered in the field. Change the value or confirm to proceed if you find that the mileage you entered is correct.',
	'mileageModal.insertedMileagePlaceholder': 'Mileage value that you entered',
	'mileageModal.pictureMileage': 'Mileage value taken from the picture',
	'mismatchModal.enteredMileage': 'Entered mileage',

	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',

	'landing.additional-informations-section.text.motorbike':
		'<ul>' +
		"<li class='landing-additional-information-line'>You are in a place with good light and mobile network</li>" +
		"<li class='landing-additional-information-line'>The vehicle is accessible from all angles.</li>" +
		'</ul>',
	'vehicleImages.description.motorbike':
		'Photograph vehicle diagonally front left and right, rear left and right. The license plate must be visible in all rear pictures.',

	'completeFourAdditionalDocumentsModal.headline': 'Hint',
	'completeFourAdditionalDocumentsModal.description': 'Please add the following information:',
	'fourAdditionalDocuments.title': 'Vehicle details',
	'fourAdditionalDocuments.RegistrationDocument.title':
		'Photo of the registration certificate (the front)',
	'fourAdditionalDocuments.RegistrationDocument.description':
		'Take a photo of the registration certificate (the front)',
	'fourAdditionalDocuments.RegistrationDocument.exampleModalTitle':
		'Photo of the registration certificate - example',
	'fourAdditionalDocuments.RegistrationDocument.headline':
		'Photo of the registration certificate (the front)',
	'fourAdditionalDocuments.RegistrationDocumentInside.title':
		'Photo of the registration certificate (the reverse)',
	'fourAdditionalDocuments.RegistrationDocumentInside.description':
		'Take a photo of the registration certificate (the reverse)',
	'fourAdditionalDocuments.RegistrationDocumentInside.exampleModalTitle':
		'Photo of the registration certificate - example',
	'fourAdditionalDocuments.RegistrationDocumentInside.headline':
		'Photo of the registration certificate (the reverse)',
	'fourAdditionalDocuments.VehicleDatasheetOutside.title':
		'Photo of the specification sheet (the front)',
	'fourAdditionalDocuments.VehicleDatasheetOutside.description':
		'Take a photo of the specification sheet (the front)',
	'fourAdditionalDocuments.VehicleDatasheetOutside.exampleModalTitle':
		'Photo of the vehicle data sheet - example',
	'fourAdditionalDocuments.VehicleDatasheetOutside.headline':
		'Photo of the specification sheet (the front)',
	'fourAdditionalDocuments.VehicleDatasheetInside.title':
		'Photo of the specification sheet (the reverse)',
	'fourAdditionalDocuments.VehicleDatasheetInside.description':
		'Take a photo of the specification sheet (the reverse)',
	'fourAdditionalDocuments.VehicleDatasheetInside.exampleModalTitle':
		'Photo of the specification sheet - example',
	'fourAdditionalDocuments.VehicleDatasheetInside.headline':
		'Photo of the specification sheet (the reverse)',
	'fourAdditionalDocuments.ITV.title': 'Photo of the ITV',
	'fourAdditionalDocuments.ITV.description': 'Take a photo of the ITV',
	'fourAdditionalDocuments.ITV.exampleModalTitle': 'Photo of the ITV - example',
	'fourAdditionalDocuments.ITV.headline': 'Photo of the ITV',

	'image.locked.RegistrationDocument':
		'Due to personal data protection, downloading registration certificate images has been blocked.',
	'image.locked.RegistrationDocumentInside':
		'Due to personal data protection, downloading registration certificate images has been blocked.',
	'image.locked.DniInside':
		'Due to personal data protection, downloading ID card images has been blocked.',
	'image.locked.DniOutside':
		'Due to personal data protection, downloading ID card images has been blocked.',
	'image.locked.VehicleDatasheetInside':
		'Due to personal data protection, downloading vehicle datasheet images has been blocked.',
	'image.locked.VehicleDatasheetOutside':
		'Due to personal data protection, downloading vehicle datasheet images has been blocked.',
	'image.locked.DriverLicenseInside':
		'Due to personal data protection, downloading driving license images has been blocked.',
	'image.locked.DriverLicenseOutside':
		'Due to personal data protection, downloading driving license images has been blocked.',
	'image.locked.ITV': 'Due to personal data protection, downloading  ITV images has been blocked.',

	'missingPhoto.title': 'Missing photo',
	'missingPhoto.description':
		'It seems that a photo is missing. Please add the missing photo to proceed.',

	'fourDiagonalPerspectives.title': 'Vehicle overview photos',

	'invalidFile.size.title': 'File too large',
	'invalidFile.size.description':
		'The selected file exceeds the maximum allowed size of 100 MB. Please choose a smaller photo.',
	'invalidFile.extension.title': 'Unsupported file format',
	'invalidFile.extension.description':
		'The selected file format is not supported. Please use JPG, PNG, BMP, HEIC or HEIF.',

	'camera.darkWarning':
		'The environment is potentially too dark — please improve the lighting for better photo quality.',

	'review.stepDescription.registrationDocument':
		'Photo of the registration certificate (the front)',
	'review.stepDescription.registrationDocumentInside':
		'Photo of the registration certificate (the reverse)',
};

export default messages;
